export default "__VITE_ASSET__016b67d4__"